import AuthGuard from "./auth_guard";

export default [
    {
        path: '/plan/projects',
        name: 'projects',
        component: () => import('../views/Plan/Project/Projects.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.planning', customName: null, disabled: true, to: {} },
            { name: 'msg.projects', customName: null, disabled: true, to: {} }
        ]
    },
    {
        path: '/plan/projects/create',
        name: 'create_project',
        component: () => import('../views/Plan/Project/CreateEditProject.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.planning', customName: null, disabled: true, to: {} },
            { name: 'msg.projects', customName: null, disabled: false, to: {name: 'projects'} },
            { name: 'msg.create', customName: null, disabled: true, to: {} }
        ]
    },
    {
        path: '/plan/projects/:id/edit',
        name: 'edit_project',
        component: () => import('../views/Plan/Project/CreateEditProject.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.planning', customName: null, disabled: true, to: {} },
            { name: 'msg.projects', customName: null, disabled: false, to: {name: 'projects'} },
            { name: null, customName: null, disabled: true, to: {} },
            { name: 'msg.edit', customName: null, disabled: true, to: {} }
        ]
    },

    {
        path: '/plan/projects/:id/tasks',
        name: 'tasks',
        component: () => import('../views/Plan/Task/Tasks.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.planning', customName: null, disabled: true, to: {} },
            { name: 'msg.projects', customName: null, disabled: false, to: {name: 'projects'} },
            { name: null, customName: null, disabled: true, to: {} },
            { name: 'msg.tasks', customName: null, disabled: true, to: {} }
        ]
    },

    {
        path: '/plan/projects/:id/report',
        name: 'tasks_report',
        component: () => import('../views/Plan/Project/Report.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.planning', customName: null, disabled: true, to: {} },
            { name: 'msg.projects', customName: null, disabled: false, to: {name: 'projects'} },
            { name: null, customName: null, disabled: false, to: {name: 'tasks'} },
            { name: 'msg.report', customName: null, disabled: true, to: {} }
        ]
    },

    {
        path: '/plan/notes',
        name: 'notes',
        component: () => import('../views/Note/Notes.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.planning', customName: null, disabled: true, to: {} },
            { name: 'msg.notes', customName: null, disabled: true, to: {} }
        ]
    },
    {
        path: '/plan/notes/create',
        name: 'create_note',
        component: () => import('../views/Note/Form.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.planning', customName: null, disabled: true, to: {} },
            { name: 'msg.notes', customName: null, disabled: false, to: {name: 'notes'} },
            { name: 'msg.create', customName: null, disabled: true, to: {} }
        ]
    },
    {
        path: '/plan/notes/:id',
        name: 'note',
        component: () => import('../views/Note/Form.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.planning', customName: null, disabled: true, to: {} },
            { name: 'msg.notes', customName: null, disabled: false, to: {name: 'notes'} },
            { name: null, customName: null, disabled: true, to: {} }
        ]
    },
]